import ProductSales from './ProductSales';

export default ProductSales;
